module.exports = __webpack_public_path__ + "img/verdi_logo.f7f7e0f2.png";